import { AppRouter } from "routes/AppRouter";
import { HelmetProvider } from "react-helmet-async";
import 'antd/dist/antd.min.css'
import "./App.css";

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <AppRouter />
    </HelmetProvider>
  );
};

export default App;